export default __webpack_public_path__ + "static/media/ccoc_2021_logo_mobile.a17e5ee8.svg";